/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import StringResources from 'nls/StringResources';
import CopyPasteHandler from 'util/CopyPasteHandler';
import { postPasteAction } from 'util/CopyPasteUtils';
import { sortCards } from './actionHelper';

function getCopyPasteHandler(layoutModel) {
	const boardModel = layoutModel.exploreVM.boardModel;
	const handler = new CopyPasteHandler({
		dashboardApi: layoutModel.getDashboardApi(),
		boardModel: boardModel,
		exploreContainerLayoutModel: layoutModel
	});
	return handler;
}

/**
 * Models the copy card action
 */
class CopyAction {
	constructor(options) {
		this.exploreVM = options.exploreVM;
		this.layoutModel = options.layoutModel;
	}

	getAttributes() {
		return {
			id: 'copy',
			//no icon yet - need to add one if this action is to appear in the toolbar
			label: StringResources.get('card_sidebar_copy'),
			className: null
		};
	}

	isEnabled(cards) {
		return !!cards.length;
	}

	action(cards) {
		//Copy cards in order they appear in the exploration
		cards = sortCards(cards, this.layoutModel);
		return getCopyPasteHandler(this.layoutModel).doCopyCards(cards);
	}
}

/**
 * Models the paste card action
 */
class PasteAction {
	constructor(options) {
		this.layoutModel = options.layoutModel;
		this.exploreVM = options.exploreVM;
	}

	getAttributes() {
		return {
			id: 'paste',
			//no icon yet - need to add one if this action is to appear in the toolbar
			label: StringResources.get('card_sidebar_paste'),
			className: null
		};
	}

	isEnabled(cards) {
		return !!cards.length;
	}

	action() {
		return getCopyPasteHandler(this.layoutModel).doPaste()
			.then(result => postPasteAction(this.exploreVM, result));
	}
}

export {
	CopyAction,
	PasteAction
};



// WEBPACK FOOTER //
// ./src/js/components/cards/actions/CopyPasteActions.js